import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const stats = [
  { valueKey: 'stats.s1.value', labelKey: 'stats.s1.label' },
  { valueKey: 'stats.s2.value', labelKey: 'stats.s2.label' },
  { valueKey: 'stats.s3.value', labelKey: 'stats.s3.label' },
  { valueKey: 'stats.s4.value', labelKey: 'stats.s4.label' },
];

export default function StatsSection() {
  const { t } = useTranslation('about');
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="w-full bg-ink-800 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-xs font-semibold text-warm-400 uppercase tracking-[0.2em] mb-3 block">
              {t('stats.label')}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              {t('stats.title')}
            </h2>
            <p className="text-sm md:text-base text-white/50 max-w-2xl mx-auto leading-relaxed">
              {t('stats.subtitle')}
            </p>
            <div className="w-16 h-1 bg-warm-500 mx-auto mt-6 rounded-full" />
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {stats.map((item, index) => (
              <div
                key={item.valueKey}
                className={`text-center py-6 md:py-8 border border-white/10 rounded-xl transition-all duration-700 ${
                  visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-warm-400 mb-2">
                  {t(item.valueKey)}
                </div>
                <div className="text-xs md:text-sm text-white/60">{t(item.labelKey)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}